export default {
  cannotInstall: {
    header: {
      feature: "Installation Error",
      heading: "Oops!",
      description:
        'We noticed you already have our app installed on the Shopify store you selected<1>{{shop}}</1>. To install on another store, it\'s easy to add another Company to your Dataships account, just log in and select "Add new company" from the Company Switcher in the navigation bar.',
      support:
        "If you need any help, please email <1>support@dataships.io</1> or book a meeting with our Customer Success team.",
    },
    buttons: {
      logIn: "Log in",
      customerSuccess: "Talk to Customer Success",
    },
  },
} as const;
